import type { PitchedContent } from "@amzn/ads-discovery-theme-service-typescript-client";
import type { ContentSalesforceObjectsAssociation } from "@amzn/ads-measurement-plm-service-type-script-client";

import { zustandStore } from "./zustand.helpers";

export interface AssociatedPitchedContent extends PitchedContent {
    associations: ContentSalesforceObjectsAssociation[];
}

export type EditContentState = {
    content?: AssociatedPitchedContent;
    shouldShowEditModal: boolean;
    onSubmitHandler?: () => void;
};

export interface EditContentActions {
    setContent: (content: AssociatedPitchedContent) => void;
    setOnSubmitHandler: (handler: () => void) => void;
    showEditModal: () => void;
    closeEditModal: () => void;
    reset: () => void;
}

export const initialState: EditContentState = {
    content: undefined,
    shouldShowEditModal: false,
    onSubmitHandler: undefined,
};

export const { store: editContentStore } = zustandStore<
    EditContentState,
    EditContentActions
>("EditContent", initialState, (set: any) => ({
    setContent: (content) => set({ content }),
    showEditModal: () => set({ shouldShowEditModal: true }),
    setOnSubmitHandler: (handler) => set({ onSubmitHandler: handler }),
    closeEditModal: () =>
        set({ content: undefined, shouldShowEditModal: false }),
    reset: () => set(initialState),
}));
